package com.dignicate.web.data.markdown.parser.core

import com.dignicate.web.data.markdown.model.MarkdownBlock

class ParsingContext(
    val lines: List<String>,
) {
    var index: Int = 0
    val blocks = mutableListOf<MarkdownBlock>()
    val metadata = mutableMapOf<String, String>()

    fun currentLine(): String? = lines.getOrNull(index)

    fun isEof(): Boolean = index >= lines.size
}
